import React from 'react';
import useScreen from 'hooks/useScreen';

// For legacy class components that cannot use hooks, this HOC can be used to
// load screen size data using the useScreen hook internally
const withScreen = ComponentToWrap => {
  const WithScreen = props => {
    // Instead of destructuring, pass through all properties from useScreen
    const screenData = useScreen();

    WithScreen.displayName = `withScreen(${ComponentToWrap.displayName ||
      ComponentToWrap.name})`;

    return <ComponentToWrap {...screenData} {...props} />;
  };

  return WithScreen;
};

export default withScreen;
